var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show_menu
      ? _c(
          "nav",
          { class: this.sidemenu_minimized, attrs: { id: "sidebar" } },
          [
            _c("ul", { staticClass: "list-unstyled" }, [
              _c(
                "li",
                {
                  class: _vm.activeRoute("enterprise_admin_dashboard")
                    ? "active"
                    : ""
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/enterprise-admin-dashboard" } },
                    [
                      _vm.activeRoute("enterprise_admin_dashboard")
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/manager/home_icon_dashboard_selected.png")
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/assets/manager/home_icon_dashboard_not_selected.png")
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "menu-item-name",
                          class: _vm.activeRoute("enterprise_admin_dashboard")
                            ? ""
                            : "text-muted"
                        },
                        [_vm._v("Home")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.checkPrimaryRole()
                ? _c(
                    "li",
                    {
                      class: _vm.activeRoute("enterprise_info") ? "active" : ""
                    },
                    [
                      _c("router-link", { attrs: { to: "/enterprise" } }, [
                        _vm.activeRoute("enterprise_info")
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/manager/admin_console_selected.png")
                              }
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/manager/admin_console_not_selected.png")
                              }
                            }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "menu-item-name",
                            class: _vm.activeRoute("enterprise_info")
                              ? ""
                              : "text-muted"
                          },
                          [_vm._v("Admin")]
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.activeRoute("locations") ? "active" : "" },
                [
                  _c("router-link", { attrs: { to: "/locations" } }, [
                    _vm.activeRoute("locations")
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/manager/Mentor_Mentee_Locations_Icon_Selected.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/manager/Mentor_Mentee_Locations_Icon_Not_Selected.png")
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "menu-item-name",
                        class: _vm.activeRoute("locations") ? "" : "text-muted"
                      },
                      [_vm._v("Locations")]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: _vm.activeRoute("enterpriseadminpathway")
                    ? "active"
                    : ""
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/enterpriseadmin/pathway" } },
                    [
                      _vm.activeRoute("enterpriseadminpathway")
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/manager/Mentor_Mentee_Pathways_Icon_Selected.png")
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/assets/manager/Mentor_Mentee_Pathways_Icon_Not_Selected.png")
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "menu-item-name",
                          class: _vm.activeRoute("enterpriseadminpathway")
                            ? ""
                            : "text-muted"
                        },
                        [_vm._v("Pathways")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: _vm.activeRoute("enterpriseadminreports")
                    ? "active"
                    : ""
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/enterpriseadmin/reports" } },
                    [
                      _vm.activeRoute("enterpriseadminreports")
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/manager/reports_selected.png")
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/assets/manager/reports_not_selected.png")
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "menu-item-name",
                          class: _vm.activeRoute("enterpriseadminreports")
                            ? ""
                            : "text-muted"
                        },
                        [_vm._v("Reports")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "list-unstyled",
                  staticStyle: { "padding-left": "9px" }
                },
                [
                  _c(
                    "li",
                    {},
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-buildable-submenu",
                              expression: "'collapse-buildable-submenu'"
                            }
                          ],
                          staticStyle: { color: "#6c757d" }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/manager/Mentor_Mentee_Users_Icon_Not_Selected.png"),
                              alt: "Buildable Items"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-item-name" }, [
                            _vm._v("Users\n          "),
                            _c("i", {
                              staticClass: "fa fa-angle-down report-dropdown",
                              staticStyle: { "font-size": "20px" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      attrs: {
                        id: "collapse-buildable-submenu",
                        visible: _vm.activeSubRoute()
                      }
                    },
                    [
                      _c("ul", { staticClass: "nav flex-column ml-3" }, [
                        _c(
                          "li",
                          {
                            class: _vm.activeRoute(
                              "enterpriselinkedaccountmanagers"
                            )
                              ? "active"
                              : ""
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/users/managers" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "menu-item-name",
                                    class: _vm.activeRoute(
                                      "enterpriselinkedaccountmanagers"
                                    )
                                      ? ""
                                      : "text-muted"
                                  },
                                  [_vm._v("Managers")]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: _vm.activeRoute(
                              "enterpriselinkedaccountmentors"
                            )
                              ? "active"
                              : ""
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/users/mentors" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "menu-item-name",
                                    class: _vm.activeRoute(
                                      "enterpriselinkedaccountmentors"
                                    )
                                      ? ""
                                      : "text-muted"
                                  },
                                  [_vm._v("Mentors")]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: _vm.activeRoute(
                              "enterpriselinkedaccountmentees"
                            )
                              ? "active"
                              : ""
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/users/mentees" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "menu-item-name",
                                    class: _vm.activeRoute(
                                      "enterpriselinkedaccountmentees"
                                    )
                                      ? ""
                                      : "text-muted"
                                  },
                                  [_vm._v("Mentees")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.activeRoute("myprofile") ? "active" : "" },
                [
                  _c("router-link", { attrs: { to: "/myprofile" } }, [
                    _vm.activeRoute("myprofile")
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/manager/my_profile_menu_icon_selected.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/manager/my_profile_menu_icon_not_selected.png")
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "menu-item-name",
                        class: _vm.activeRoute("myprofile") ? "" : "text-muted"
                      },
                      [_vm._v("My Profile")]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.activeRoute("logout") ? "active" : "" },
                [
                  _c("router-link", { attrs: { to: "/logout" } }, [
                    _vm.activeRoute("logout")
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/manager/sign_out_menu_icon.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/manager/sign_out_menu_icon.png")
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "menu-item-name",
                        class: _vm.activeRoute("logout") ? "" : "text-muted"
                      },
                      [_vm._v("Sign Out")]
                    )
                  ])
                ],
                1
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.show_back_button
      ? _c(
          "nav",
          {
            class: _vm.show_back_button ? "sidebar_view_mentee" : "",
            attrs: { id: "sidebar" }
          },
          [
            _c("ul", { staticClass: "list-unstyled" }, [
              _c(
                "li",
                {},
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "text-uppercase text-muted pt-1",
                      attrs: {
                        to: this.back_link
                          ? { name: this.back_link }
                          : "/enterprise-admin-dashboard"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "back_icon mr-2",
                        attrs: {
                          src: require("@/assets/manager/back_button_icon.png")
                        }
                      }),
                      _vm._v("\n          Back\n        ")
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be4da506", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be4da506","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/enterpriseadmin_sidebar_menu.vue
// module id = null
// module chunks = 